import { Helper } from "./../../shared/helpers/helper";
import { catchError, map } from "rxjs/operators";

import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Table } from "src/app/shared/models/table.model";
import { BASE_BACKEND, ENDPOINT } from "src/app/shared/http/api";

@Injectable()
export class UpdateDatabaseService {
  constructor(private http: HttpClient) {}

  getTables(queryParams?: string): Promise<Table[]> {
    return this.http
      .get(`${BASE_BACKEND}${ENDPOINT.updateDatabase.tables}?${queryParams}`)
      .toPromise()
      .then((data) => data)
      .catch((error) => error);
  }

  updateTable(endpoint) {
    return this.http
      .put(`${BASE_BACKEND}${ENDPOINT.updateDatabase.base}/${endpoint}`, {})
      .pipe(
        map((data) => data),
        catchError(Helper.handleError)
      );
  }
}
